import React, { useState } from 'react';
import { Book } from '../../types/Book';
import './OnlineBookReader.css';

interface OnlineBookReaderProps {
  book: Book;
  onClose: () => void;
}

const OnlineBookReader: React.FC<OnlineBookReaderProps> = ({ book, onClose }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);



  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };

  const handleIframeError = () => {
    setError('Failed to load book content from Project Gutenberg');
    setIframeLoaded(true);
  };

  const getGutenbergUrl = (bookId: string) => {
    return `https://www.gutenberg.org/cache/epub/${bookId}/pg${bookId}-images.html`;
  };

  const gutenbergUrl = getGutenbergUrl(book.id);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <div className="online-reader-container">
      <div className="reader-header">
        <button className="menu-btn" onClick={toggleDrawer} title="Menu">
          ☰
        </button>
        <div className="book-info-header">
          <h1>{book.title}</h1>
          <p>by {book.author}</p>
        </div>
      </div>

      {/* Drawer Menu */}
      {isDrawerOpen && (
        <>
          <div className="drawer-overlay" onClick={closeDrawer}></div>
          <div className="drawer-menu">
            <div className="drawer-header">
              <h3>Menu</h3>
              <button className="close-drawer-btn" onClick={closeDrawer}>
                ✕
              </button>
            </div>
            <div className="drawer-content">
              <button className="drawer-item back-btn" onClick={onClose}>
                ← Back to Library
              </button>
              <button 
                className="drawer-item open-external-btn"
                onClick={() => {
                  window.open(gutenbergUrl, '_blank');
                  closeDrawer();
                }}
              >
                🔗 Open in New Tab
              </button>
            </div>
          </div>
        </>
      )}

      <div className="reader-content">
        {!iframeLoaded && (
          <div className="iframe-loading">
            <div className="loading-spinner-large"></div>
            <p>Loading book content from Project Gutenberg...</p>
          </div>
        )}
        
        <iframe
          src={gutenbergUrl}
          title={`Read ${book.title} by ${book.author}`}
          className={`book-iframe ${iframeLoaded ? 'loaded' : ''}`}
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          style={{
            width: '100%',
            maxWidth: '100vw',
            height: '100%',
            border: 'none',
            boxSizing: 'border-box'
          }}
        />
        
        {error && (
          <div className="iframe-error">
            <h3>Content Loading Error</h3>
            <p>{error}</p>
            <p>
              You can try <a href={gutenbergUrl} target="_blank" rel="noopener noreferrer">
                opening the book directly on Project Gutenberg
              </a>.
            </p>
            <button className="close-error-btn" onClick={onClose}>
              ← Back to Library
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OnlineBookReader;
